<template>
    <div>

        <div style="width: 30%;float: left" class="el-scrollbar">
            <div class="el-scrollbar__wrap">
                <div class="el-scrollbar-item"><a disabled class="gray">工艺记录单</a></div>
                <div class="el-scrollbar-item"><router-link to="/document/mdf_craft">修改通知单</router-link></div>
            </div>
        </div>
        <div style="width: 70%;float: left;margin-left: 30%" class="el-scrollbar-main">
            <div class="el-scrollbar__wrap-main">
                <router-view></router-view>
            </div>
        </div>

    </div>
</template>

<script>
    export default {
        name: "UseDocument"
    }
</script>

<style scoped>

</style>